import { useState } from 'react';
import { useReports } from '@/lib/hooks/useReports';
import { PageHeader } from '@/components/ui/page-header';
import { Toggle } from '@/components/ui/toggle';
import { ReportsMetricsCards } from '@/components/reports/ReportsMetricsCards';
import { ReportsTimeline } from '@/components/reports/ReportsTimeline';
import { ReportsCampaignTable } from '@/components/reports/ReportsCampaignTable';
import { ReportsExportButton } from '@/components/reports/ReportsExportButton';

type TimeRange = '7d' | '30d' | '90d' | 'all';

export default function ReportsPage() {
  const [timeRange, setTimeRange] = useState<TimeRange>('30d');
  const { overview, timeline, campaigns, isLoading, error } = useReports(timeRange);

  const timeRangeOptions: { value: TimeRange; label: string }[] = [
    { value: '7d', label: '7 Days' },
    { value: '30d', label: '30 Days' },
    { value: '90d', label: '90 Days' },
    { value: 'all', label: 'All Time' },
  ];

  return (
    <>
      <PageHeader title="Reports" className="mt-page-top mb-header-gap" />

      <div className="w-full px-gutter mb-10" style={{ contain: 'layout paint' }}>
        <div className="flex justify-between items-center mb-6">
          <Toggle<TimeRange>
            options={timeRangeOptions}
            value={timeRange}
            onChange={setTimeRange}
          />
          <ReportsExportButton timeRange={timeRange} />
        </div>

        {error && (
          <div className="bg-danger-surface-strong rounded-md p-4 mb-6">
            <p className="text-sm text-danger-foreground-strong">
              Failed to load reports. Please try again.
            </p>
          </div>
        )}

        <div>
          {/* Metrics Cards - pass isLoading */}
          {(overview || isLoading) && <ReportsMetricsCards metrics={overview || { sent: 0, opened: 0, clicked: 0, replied: 0, openRate: 0, clickRate: 0, replyRate: 0 }} isLoading={isLoading} />}

          {/* Timeline Chart - pass isLoading */}
          <ReportsTimeline data={timeline} isLoading={isLoading} />

          {/* Campaign Performance Table - pass isLoading */}
          <div>
            <ReportsCampaignTable campaigns={campaigns} isLoading={isLoading} />
          </div>
        </div>
      </div>
    </>
  );
}
